var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{staticClass:"section-heading"},[_vm._v(_vm._s(_vm.$t('description_text')))]),_c('TinymceEditor',{attrs:{"value":_vm.record.description,"init":_vm.tmceConfig,"placeholder":_vm.$t('event_description_placeholder')},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }